module.exports = __webpack_public_path__ + "img/甘肃经济广播_01.f15b9f84.jpg";